import { render, staticRenderFns } from "./SlImage.vue?vue&type=template&id=70c53e79&scoped=true&"
import script from "./SlImage.vue?vue&type=script&lang=js&"
export * from "./SlImage.vue?vue&type=script&lang=js&"
import style0 from "./SlImage.vue?vue&type=style&index=0&id=70c53e79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c53e79",
  null
  
)

export default component.exports